import { Button } from '@/components/ui/button'
import { LvdDeclarationReadinessProgress } from '@/v2/components/lvd/LvdDeclarationReadinessProgress'
import type { LvdProductComplianceFileDeclarationOfConformityRequirement } from '@/v2/lib/lvdProductComplianceFileDeclarationOfConformityRequirements'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { V2LvdLegislationBriefingStepShell } from './V2LvdLegislationBriefingStepShell'

export function V2LvdEuDeclarationStep({
  step,
  index,
  declarationLabel,
  declarationEvaluation,
  onOpenDeclarationDialog,
}: {
  step: LvdBriefingStep
  index: number
  declarationLabel: string
  declarationEvaluation: {
    requirements: LvdProductComplianceFileDeclarationOfConformityRequirement[]
    generateReady: boolean
  } | null
  onOpenDeclarationDialog: () => void
}) {
  const showReadiness =
    step.status !== 'done' && declarationEvaluation != null
  const showGenerateAction = declarationEvaluation != null

  return (
    <V2LvdLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        showGenerateAction ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onOpenDeclarationDialog}
          >
            {declarationLabel}
          </Button>
        ) : undefined
      }
    >
      {showReadiness ? (
        <LvdDeclarationReadinessProgress
          requirements={declarationEvaluation.requirements}
          generateReady={declarationEvaluation.generateReady}
        />
      ) : null}
    </V2LvdLegislationBriefingStepShell>
  )
}
